module.exports = __webpack_public_path__ + "static/media/laxmirajW1.bb07123c.png";